import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  ReactNode,
  SetStateAction,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

import { AppLayoutPagePropsI } from "@/interfaces/layout";

type AppLayoutProviderPropsI = PropsWithChildren;

interface AppLayoutContextI {
  appLayoutPageProps: AppLayoutPagePropsI;
  setAppLayoutTitle: (title?: ReactNode) => void;
  setAppLayoutPageProps: Dispatch<SetStateAction<AppLayoutPagePropsI>>;
}

const AppLayoutContext = createContext<AppLayoutContextI>({
  appLayoutPageProps: {},
  setAppLayoutTitle: () => {},
  setAppLayoutPageProps: () => {},
});

export const useAppLayoutContext = (): AppLayoutContextI =>
  useContext(AppLayoutContext);

export const useSetLayoutParams = (params: AppLayoutPagePropsI) => {
  const { setAppLayoutPageProps } = useAppLayoutContext();

  useEffect(() => {
    setAppLayoutPageProps(params);
  }, [params]);
};

export const AppLayoutProvider: FC<AppLayoutProviderPropsI> = ({
  children,
}) => {
  const [appLayoutPageProps, setAppLayoutPageProps] =
    useState<AppLayoutPagePropsI>({});

  const setAppLayoutTitle = useCallback(
    (title?: ReactNode) =>
      setAppLayoutPageProps((currentLayoutPageProps) => ({
        ...currentLayoutPageProps,
        title,
      })),
    []
  );

  return (
    <AppLayoutContext.Provider
      value={{
        appLayoutPageProps,
        setAppLayoutTitle,
        setAppLayoutPageProps,
      }}
    >
      {children}
    </AppLayoutContext.Provider>
  );
};
